import $ from 'jquery';
import { find } from 'lodash';
import dispatcher from '../../lib/dispatcher';
import {
  EVENTS
} from '../../lib/constants';
import {associationsFallbackData, associationsFalbackData_fr} from '../../data/associations';

const migrationsMobile = {
  selectedProvinceCode: '',
  init(config) {
    dispatcher.on(EVENTS.ProvinceSelected, ({ province, code, postalCode }) => {
      this.updateDealerLocator(config, postalCode, code);
      this.updateSpecialOffers(config, code);
      this.updateTireWizard(postalCode, code);
      this.selectedProvinceCode = code;
    });
  },

  getAssociations(config) {
    //TODO: need to get associations fro API
    var fallbackAssociations = config.language === 'en' ? associationsFallbackData : associationsFalbackData_fr;
    return fallbackAssociations;
  },

  updateDealerLocator(config, postalCode, provinceCode) {
    if ($('#dealer-locator').length) {
      window.updateDealerLocatorLocation (postalCode, provinceCode);
    } else if ($('.dealer-locator.search-results').length ) {
      let url = config.language === 'en' ? '/dealerlocator' : '/trouver-concessionaire';

      if (window.location.pathname !== url && ['', provinceCode].indexOf(this.selectedProvinceCode) < 0)
        window.location.href = url;
    }
  },

  updateSpecialOffers(config, provinceCode) {
    if ($('#special-offers-page').length) {
      const associations = this.getAssociations(config);
      const association = find(associations, {Province: {Abbreviation: provinceCode}});
      let url = config.language === 'en' ? '/special-offers-national' : '/offres-speciales-national';
      if (association) {
        url = association.Url;
      }
      if (window.location.pathname.indexOf(url) < 0)
        window.location.href = url;
    }
  },

  updateTireWizard(postalCode, provinceCode) {
    if ($('.tire-finder-wrapper .tire-wizard-region-contain').length) {
      if (postalCode !== '') {
        $('.tire-wizard-postal-contain input').val(postalCode);
        $('.tire-wizard-btn-go').trigger('click')
      } if (isProvinceCodeSupported(provinceCode)) {
        $('.tire-wizard-region-contain select').val(provinceCode).trigger('onchange');
      } else {
        $('.tire-wizard-dealer-listing').hide();
        $('.tire-wizard-region-contain select').val('-1');
      }
    }
  }
}

function isProvinceCodeSupported(provinceCode) {
  return [undefined, null, '', 'NT', 'NU','PE', 'YT'].indexOf(provinceCode) < 0;
}

window.updateDealerLocatorLocation = function (postalCode, provinceCode) {
  if (postalCode !== '') {
    $('.location-postal-code').val(postalCode);
    $('.search-by-postal').trigger('click');
  } else {
    if (isProvinceCodeSupported(provinceCode)) {
      $('select.location-province').val(provinceCode);
      $('.search-by-region').trigger('click');
    } else {
      $('select.location-province').val('ON');
    }
  }
}
export default migrationsMobile;



// WEBPACK FOOTER //
// ./src/apps/acuraca/mobile.migrations.js